<template>
    <div v-if="client">
        <!-- authentication required -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Authentication required</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input
                                v-model="client.settings.viewSettings.auth.authenticationRequired"
                                type="checkbox"
                            />
                        </label>
                    </p>
                </div>
            </div>
        </div>
        <!-- authentication hide bars -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Authentication: hide bars</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input
                                v-model="client.settings.viewSettings.auth.authenticationHideBars"
                                type="checkbox"
                            />
                        </label>
                    </p>
                </div>
            </div>
        </div>
        <!-- ask alias during registration -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Ask alias during registration</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input
                                v-model="client.settings.viewSettings.auth.askAliasDuringRegistration"
                                type="checkbox"
                            />
                        </label>
                    </p>
                </div>
            </div>
        </div>
        <!-- sport quick login -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Sport quick login</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input
                                v-model="client.settings.viewSettings.auth.sportQuickLogin"
                                type="checkbox"
                            />
                        </label>
                    </p>
                </div>
            </div>
        </div>
        <!-- is password restore allowed -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Password restore allowed</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input
                                v-model="client.settings.viewSettings.auth.passwordRestoreAllowed"
                                type="checkbox"
                            />
                        </label>
                    </p>
                </div>
            </div>
        </div>
        <!-- unsafe reset password allowed -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Unsafe reset password allowed</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input v-model="client.settings.viewSettings.auth.isUnsafeResetPasswordAllowed" type="checkbox" />
                        </label>
                    </p>
                </div>
            </div>
        </div>

        <!-- save -->
        <div class="field is-horizontal">
            <div class="field-label"></div>
            <div class="field-body">
                <div class="field is-grouped">
                    <div class="control">
                        <button @click="save" class="button is-primary">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import state from '../../../../../state';
import utils from '../../../../../utils';
import clientService from '../../../../../services/client.service';

export default {
    name: 'client-settings-view-auth',
    data() {
        return {
            client: null
        };
    },
    computed: {
        clientId() {
            return Number(this.$route.params.clientId);
        }
    },
    watch: {
        clientId() {
            this.loadClient();
        }
    },
    async mounted() {
        await clientService.ensure();
        this.loadClient();
    },
    methods: {
        loadClient() {
            this.client = utils.clone(state.clients.getClient(this.clientId));
        },
        async save() {
            await clientService.save(this.client);
            this.loadClient();
        }
    }
};
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/settings/view/auth.vue